import { render, staticRenderFns } from "./ShopGroupDialog.vue?vue&type=template&id=44b90b62&scoped=true"
import script from "./ShopGroupDialog.vue?vue&type=script&lang=ts"
export * from "./ShopGroupDialog.vue?vue&type=script&lang=ts"
import style0 from "./ShopGroupDialog.vue?vue&type=style&index=0&id=44b90b62&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44b90b62",
  null
  
)

export default component.exports